import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";

interface FetchQuestionPayload {
  question?: any;
  [key: string]: any;
}

export const useQuestionModal = () => {
  const dispatch = useDispatch();

  const [modalQuestion, setModalQuestion] = useState<any>({});
  const [showQuestionModal, setShowQuestionModal] = useState<boolean>(false);
  const [apiloader, setapiloader] = useState<boolean>(false);
  const fetchQuestion = useCallback(
    (url: string, ques: FetchQuestionPayload) => {
      setapiloader(true);

      getAPIRequest({
        url: url,
        success: (res: any) => {
          const { data: response } = res || {};
          const { data: dataRes } = response || {};
          const engQuesContent = dataRes[0] || {};
          const hindiQuesContent = dataRes[1] || {};

          const newQuestion = {
            ...ques,
            previewQuestion: dataRes.data,
            question: {
              ...ques.question,
              defaultQuestionLanguage: engQuesContent,
              hindiQuestionLanguage: hindiQuesContent,
            },
          };
          setModalQuestion(newQuestion);
          setShowQuestionModal(true);
          setapiloader(false);
        },
        failure: (err: any) => {
          console.log(err);
        },
      });
    },
    [dispatch]
  );

  return {
    fetchQuestion,
    modalQuestion,
    showQuestionModal,
    apiloader,
    setShowQuestionModal,
  };
};
